var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"main-content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"main-content-vfg"},[_c('vue-form-generator',{ref:'vfg',attrs:{"schema":_vm.formSchema.pages[0].schema,"model":_vm.formSchema.model,"options":_vm.formSchema.options},on:{"on-complete":_vm.onComplete}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }